if (!customElements.get('daziner-article-reading')) {
  customElements.define(
    'daziner-article-reading',
    class extends HTMLElement {
      connectedCallback() {
        const content = this.querySelector('.article-template__content');
        const toc = this.querySelector('.dz-article__toc');
        const outline = toc?.querySelector('.dz-article__outline');
        if (!content || !outline || this.dataset.ready) return;

        this.dataset.ready = 'true';
        for (const table of content.querySelectorAll('table')) {
          const frame = document.createElement('div');
          frame.className = 'dz-article__table';
          table.before(frame);
          frame.append(table);
        }

        const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
        const headingTargets = new Set(
          Array.from(content.querySelectorAll('h2[id], h3[id]'), (heading) => '#' + heading.id)
        );
        const authoredOutline = Array.from(content.querySelectorAll('nav[aria-label]')).find((nav) => {
          const label = nav.getAttribute('aria-label');
          return /contents|on this page/i.test(label)
            && Array.from(nav.querySelectorAll('a[href^="#"]')).filter((link) => headingTargets.has(link.hash)).length >= 2;
        });

        if (authoredOutline) {
          outline.append(authoredOutline);
        } else if (headings.length >= 3) {
          const nav = document.createElement('nav');
          nav.setAttribute('aria-label', 'Article contents');
          const list = document.createElement('ol');
          headings.forEach((heading, index) => {
            if (!heading.id) {
              const base = 'article-section-' + (index + 1);
              let id = base;
              let suffix = 2;
              while (document.getElementById(id)) id = base + '-' + suffix++;
              heading.id = id;
            }
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = '#' + encodeURIComponent(heading.id);
            link.textContent = heading.textContent.trim();
            item.append(link);
            list.append(item);
          });
          nav.append(list);
          outline.append(nav);
        } else {
          return;
        }

        const desktop = matchMedia('(min-width: 990px)');
        toc.open = desktop.matches;
        toc.hidden = false;
        outline.addEventListener('click', (event) => {
          if (!desktop.matches && event.target.closest('a[href^="#"]')) toc.open = false;
        });
      }
    }
  );
}
